import { Options } from 'highcharts';
import { LayoutBounds } from '../widgets/layout';

export abstract class ChartOptionFactory<TData, TSettings> {
  public abstract getOptions(data: TData, settings: TSettings, layout?: LayoutBounds | undefined): Options;

  protected getDefaultOptions(): Options {
    return {
      title: undefined,
      chart: {
        plotBackgroundColor: 'transparent',
      },
      tooltip: {
        valueDecimals: 2,
        animation: false,
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: false,
        },
      },
    };
  }
}
